/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import type { IconProps } from './types/index';

function IcCheckRegular({ className, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 24 24"
      className={`kc-console-icon ${className ? className : ''}`}
      {...props}
    >
      <path
        fillRule="evenodd"
        d="M20.638 5.866a.9.9 0 0 1-.004 1.273l-11.077 11a.9.9 0 0 1-1.268 0l-4.924-4.89a.9.9 0 0 1 1.269-1.276l4.289 4.259 10.442-10.37a.9.9 0 0 1 1.273.004"
        clipRule="evenodd"
      />
    </svg>
  );
}
export default IcCheckRegular;
